import { makeStyles, Theme } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme: Theme) => ({
  marginBottom10: {
    marginBottom: 10,
  },
  selectCheck: {
    width: 250,
  },
  marginTop15: {
    marginTop: 15,
  },
  marginTop10: {
    marginTop: 10,
  },
  g_name: {
    marginTop: 20,
  },
  g_name1: {
    marginTop: 24,
  },
  customTextField: {
    borderWidth: 2,
    borderRadius: 5,
    borderColor: "#C5C5C5",
    padding: 10,
    "&:hover": {
      borderColor: "#C4122F",
    },
    "&::placeholder": {
      color: "#C5C5C5",
      fontSize: 16,
    },
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: "#C4122F",
    whiteSpace: "nowrap",
    marginBottom: theme.spacing(1),
  },
  closeButton: {
    border: "0.5px solid #E08489",
    width: 100,
    height: 40,
    borderRadius: 5,
    "&:hover": {
      borderColor: "#c4122f",
    },
  },
  padding5: {
    paddingLeft: 25,
    paddingRight: 25,
  },
  person: { paddingTop: 2, fontSize: 26 },
  iconPerson: { marginRight: 10, marginTop: 5 },
  iconDelete: {
    margin: 0,
  },
  total: { marginLeft: 15, paddingTop: 12, fontWeight: "bold" },
  panelContainer1: { width: "100%", "&:hover": { backgroundColor: "#F5F5F5" } },
  panelContainer2: {
    width: "100%",
    borderTop: "1px solid #E0E0E0",
    "&:hover": { backgroundColor: "#F5F5F5" },
  },
  panelRow: {
    width: "33%",
    paddingBottom: "1.3%",
    paddingTop: 15,
    paddingLeft: "10%",
    fontWeight: "inherit",
    fontFamily: `"Work Sans", "Arial", "sans-serif"`,
    fontSize: "0.875rem",
  },
  panelEmail: {
    width: "59%",
    paddingBottom: "1.3%",
    paddingTop: 15,
    fontWeight: "inherit",
    fontFamily: `"Work Sans", "Arial", "sans-serif"`,
    fontSize: "0.875rem",
  },
  deleteIcon: { display: "flex", justifyItems: "flex-end", marginRight: 5 },
  icon: { fontWeight: "bold", color: "black" },
  label: {
    fontSize: 16,
    paddingTop: 10,
  },
  select: {
    width: 250,
  },
  row: {
    "&:css-1x51dt5-MuiInputBase-input-MuiInput-input": {
      color: "red",
    },
  },
  lableFontSize: {
    fontSize: "x-small",
    fontFamily: `"Work Sans", "Arial", "sans-serif"`,
    marginBottom: 10,
  },
  button: {
    "& .MuiButton-startIcon": {
      transition: "transform 0.5s",
    },
    "&.rotate .MuiButton-startIcon": {
      transform: "rotate(90deg)",
    },
  },
}));
